import React, { useEffect } from 'react';
import './AssetEdit.scss';
import { assetDetailAction } from 'actions/assetDetails';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import Loading from 'components/Placeholders/Loading';
import { findElementByPrompt } from 'utils/utils';
import AssetEditContent from 'componentsV2/AssetEditContent/AssetEditContent';
import { singleUploadActions } from 'actions/singleUpload';
import ProductValidation from 'componentsV2/AssestUpload/SingleUpload/ProductValidation';
import HeadingNavBar from 'componentsV2/HeadingNavBar/HeadingNavBar';
import { useLocation } from 'react-router';
import { HOME_PAGE } from 'constants/routes';

const AssetEdit: React.FC = () => {
  const [activeTab, setActiveTab] = React.useState('Metadata');
  const [assetDetails, setAssetDetails] = React.useState<any>(null);
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  const loading = useSelector((state: any) => state.loading.isLoading);
  const url = window.location.href;
  const assetId = url.split('/').pop() || ''; // Ensure assetId is always a string
  const location = useLocation();
  const fromPage = (location.state as any)?.from || HOME_PAGE; // Default to 'home' if not specified
  

  useEffect(() => {
    const fetchAssetDetails = async () => {
      try {
        // Get the asset ID from the URL
        dispatch({ type: 'LOADING SUCCESS', payload: true });  
        if (!assetId) {
          console.error('Asset ID is undefined. Unable to fetch asset details.');
          return;
        }
  
        // Fetch asset details using the asset ID
        const response = await assetDetailAction.getAssetDetails(assetId);
        dispatch({ type: 'LOADING SUCCESS', payload: false });

        setAssetDetails(response);
        dispatch(
          singleUploadActions.updateSingleUploadPayload(
            response
          )
        );
      } catch (error) {
        dispatch({ type: 'LOADING SUCCESS', payload: false });
        console.error('Error fetching asset details:', error);
      }
    };
  
    fetchAssetDetails();
  }, []);

  const nameId = findElementByPrompt(assetDetails, 'Name');

  useEffect(() => {
    document.title = 'Asset Edit';
  }, []);

  return (
    <div className="asset-edit" data-testid="asset-edit">
      <HeadingNavBar activeTab={activeTab} pageTitle={nameId?.value?.display_value || nameId?.value?.id} name={assetDetails?.name ? ` ${assetDetails.name}` : ''}  assetDetails={assetDetails} 
        from={fromPage}/>
      {/* Render content based on active tab */}
      {activeTab.includes("Metadata") && (
        <AssetEditContent assetDetails={assetDetails} assetId={assetId || ''} />
      )}
      {activeTab === "Versions" && (
        <div className="asset-edit-content">
          <h2>Versions</h2>
          <p>Content for Versions tab will be displayed here.</p>
        </div>
      )}
      {loading && <Loading/>}
      <ProductValidation />

    </div>
  );
};

export default AssetEdit;